import React, {useState, useRef, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { 
    Flex, Button, ButtonGroup, Text, CircularProgress,
    Icon, IconButton, Select, HStack, Image, Center, Link, useDisclosure, 
} from '@chakra-ui/react';
import { MdCheck } from 'react-icons/md';
import { withNamespaces } from 'react-i18next';
import { PRICING_LIST, PRICING_LIST_EN, REGISTER_TYPE, REGISTER_TYPE_EN } from "../../constants";
import i18n from '../../i18n';
import RegisterCompanyModal from "./Modals/RegisterCompanyModal"
import ExtendCompanyModal from "./Modals/ExtendCompanyModal"

function Pricing(props) {
    const navigate = useNavigate();
    const { company_id } = useParams();
    const [ register_type, setRegisterType ] = useState(null);
    const [ type, setType ] = useState("NEW")

    const mounted = useRef();
    const initialRef = useRef(null);
    const registerCompanyModal = useDisclosure();
    const extendCompanyModal = useDisclosure();

    useEffect(() => {
        if(!mounted.current) {
            if(company_id) {
                setType("EXTEND");
            }
            mounted.current = true;
        }
    });

    const handleOpenPricingService = (register_type) => {
        if(type === "NEW") {
            registerCompanyModal.onOpen()
        } else if(type === "EXTEND") {
            extendCompanyModal.onOpen()
        }

        setRegisterType(register_type)
    }

    const t = props.t;
    const PLAN_LIST = i18n.language === "en" ? PRICING_LIST_EN : PRICING_LIST;
    const PLAN_TYPE = i18n.language === "en" ? REGISTER_TYPE_EN : REGISTER_TYPE;

    return (
        <React.Fragment>
            <Flex flexDirection="column" alignItems="center" justifyContent="center" width="100%" height="100%" backgroundColor="rgba(247, 248, 251, 1)" px={4}>
                <Flex align="flex-end" gap={2}>
                    <Image mt="2vh" alt="logo" src="/images/moc_tra_soft_logo.png" />
                    <Link href='/' _hover={{ textDecoration: "none" }}>
                        <Text fontSize="30px" fontWeight="700" color="green.500">MỘC TRÀ SOFT</Text>
                    </Link>
                </Flex>
                <Text fontSize={{ base: "36px", md: "56px", lg: "56px" }} fontWeight="700" color="rgba(28, 28, 28, 1)" textAlign="center" textTransform="uppercase">
                    {t("Pricing_Detail")}
                </Text>

                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} gap={4} width="100%" p={{ base: 2, md: 8, lg: 8 }} justify="center">
                    {
                        type === "NEW" &&
                        <Flex flexDirection="column" mt="10px" padding={{ base: "20px", md: "20px", lg: "20px" }} 
                            w={{ base: "100%", md: "33%", lg: "33%" }} minH="100%" color="rgba(255, 255, 255, 1)" 
                            backgroundImage="/images/backgrounds/DarkGradient08.png" backgroundPosition="53% 50%"
                            borderRadius={16} boxShadow="lg"
                        >
                            <Text fontSize="30px" fontWeight="700" color="rgba(254, 183, 1, 1)">{PLAN_LIST["FREE"]["label"]}</Text>
                            <Text fontSize="24px" fontWeight="700" color="#9c27b0">{PLAN_LIST["FREE"]["period"]}</Text>
                            <Text mt="15px" fontSize="30px" color="#76ff03">{PLAN_LIST["FREE"]["price"]}</Text>
                            <Text visibility="hidden"><del>{PLAN_LIST["FREE"]["old_price"]}</del></Text>
                            <Center mt={2}>
                                <Select backgroundColor="green.400" fontWeight={700} color="rgba(28, 28, 28, 1)" 
                                    textAlign="center" maxW={{ base: "100%", md: "50%", lg: "50%" }} 
                                    value={type} onChange={(evt) => setType(evt.currentTarget.value)}
                                >
                                    {
                                        Object.keys(PLAN_TYPE).map(key => (
                                            <React.Fragment key={key}>
                                                <option value={key}>
                                                    {PLAN_TYPE[key]}
                                                </option>
                                            </React.Fragment>
                                        ))
                                    }
                                </Select>
                            </Center>

                            <Text fontWeight="700" my="5px">{t("Detail")}</Text>
                            {
                                PLAN_LIST["FREE"]["context"].map((data, idx) => {
                                    return (
                                        <HStack key={`free-${idx}`}>
                                            <Icon boxSize={6} as={MdCheck} color="rgba(255, 188, 0, 1)" /> 
                                            <Text as={data.isBold ? "b" : ""}>{data.text}</Text>
                                        </HStack>
                                    )
                                })
                            }
                            <Button mt={2} backgroundColor="rgba(255, 188, 0, 1)" color="rgba(28, 28, 28, 1)" borderRadius="32px"
                                onClick={() => handleOpenPricingService("FREE")} textTransform="uppercase"
                            >
                                {type === "NEW" ? t("Register") : t("Extend")}
                            </Button>
                        </Flex>
                    }

                    <Flex flexDirection="column" mt="10px" padding="20px" w={{ base: "100%", md: "33%", lg: "33%" }} minH="100%" 
                        backgroundColor="rgba(28, 28, 28, 1)" color="rgba(255, 255, 255, 1)"
                        borderRadius={16} boxShadow="lg"
                    >
                        <Text fontSize="30px" fontWeight="700">{PLAN_LIST["BASIC"]["label"]}</Text>
                        <Text fontSize="24px" fontWeight="700" color="#9c27b0">{PLAN_LIST["BASIC"]["period"]}</Text>
                        <Text mt="15px" fontSize="30px" color="#76ff03">{PLAN_LIST["BASIC"]["price"]}</Text>
                        <Text fontSize="18px"><del>{PLAN_LIST["BASIC"]["old_price"]}</del></Text>
                        <Center mt={2}>
                            <Select backgroundColor="green.400" fontWeight={700} color="rgba(28, 28, 28, 1)" 
                                textAlign="center" maxW={{ base: "100%", md: "50%", lg: "50%" }} 
                                value={type} onChange={(evt) => setType(evt.currentTarget.value)}
                            >
                                {
                                    Object.keys(PLAN_TYPE).map(key => (
                                        <React.Fragment key={key}>
                                            <option value={key}>
                                                {PLAN_TYPE[key]}
                                            </option>
                                        </React.Fragment>
                                    ))
                                }
                            </Select>
                        </Center>

                        <Text fontWeight="700" my="5px">{t("Detail")}</Text>
                        {
                            PLAN_LIST["BASIC"]["context"].map((data, idx) => {
                                return (
                                    <HStack key={`basic-${idx}`}>
                                        <Icon boxSize={6} as={MdCheck} color="rgba(255, 188, 0, 1)" /> 
                                        <Text as={data.isBold ? "b" : ""}>{data.text}</Text>
                                    </HStack>
                                )
                            })
                        }
                        <Button mt={2} backgroundColor="rgba(255, 188, 0, 1)" color="rgba(28, 28, 28, 1)" borderRadius="32px"
                            onClick={() => handleOpenPricingService("BASIC")} textTransform="uppercase"
                        >
                            {type === "NEW" ? t("Register") : t("Extend")}
                        </Button>
                    </Flex>

                    <Flex flexDirection="column" mt="10px" padding="20px" w={{ base: "100%", md: "33%", lg: "33%" }} minH="100%" color="rgba(255, 255, 255, 1)"
                        backgroundImage="/images/backgrounds/DarkGradient12.png" backgroundPosition="53% 50%"
                        borderRadius={16} boxShadow="lg"
                    >
                        <Text fontSize="30px" fontWeight="700">{PLAN_LIST["PRO"]["label"]}</Text>
                        <Text fontSize="24px" fontWeight="700" color="#9c27b0">{PLAN_LIST["PRO"]["period"]}</Text>
                        <Text mt="15px" fontSize="30px" color="#76ff03">{PLAN_LIST["PRO"]["price"]}</Text>
                        <Text><del>{PLAN_LIST["PRO"]["old_price"]}</del></Text>
                        <Center mt={2}>
                            <Select backgroundColor="green.400" fontWeight={700} color="rgba(28, 28, 28, 1)" 
                                textAlign="center" maxW={{ base: "100%", md: "50%", lg: "50%" }} 
                                value={type} onChange={(evt) => setType(evt.currentTarget.value)}
                            >
                                {
                                    Object.keys(PLAN_TYPE).map(key => (
                                        <React.Fragment key={key}>
                                            <option value={key}>
                                                {PLAN_TYPE[key]}
                                            </option>
                                        </React.Fragment>
                                    ))
                                }
                            </Select>
                        </Center>

                        <Text fontWeight="700" my="5px">{t("Detail")}</Text>
                        {
                            PLAN_LIST["PRO"]["context"].map((data, idx) => {
                                return (
                                    <HStack key={`pro-${idx}`}>
                                        <Icon boxSize={6} as={MdCheck} color="rgba(255, 188, 0, 1)" /> 
                                        <Text as={data.isBold ? "b" : ""}>{data.text}</Text>
                                    </HStack>
                                )
                            })
                        }
                         <Button mt={2} backgroundColor="rgba(255, 188, 0, 1)" color="rgba(28, 28, 28, 1)" borderRadius="32px"
                            onClick={() => handleOpenPricingService("PRO")} textTransform="uppercase"
                        >
                            {type === "NEW" ? t("Register") : t("Extend")}
                        </Button>
                    </Flex>
                </Flex>
            </Flex>
            {
                registerCompanyModal.isOpen &&
                <RegisterCompanyModal 
                    initialRef={initialRef} isOpen={registerCompanyModal.isOpen} onClose={registerCompanyModal.onClose}
                    register_type={register_type}
                />
            }
            {
                extendCompanyModal.isOpen &&
                <ExtendCompanyModal 
                    initialRef={initialRef} isOpen={extendCompanyModal.isOpen} onClose={extendCompanyModal.onClose}
                    register_type={register_type} company_id={company_id}
                />
            }
        </React.Fragment>
    )
}

export default withNamespaces()(Pricing);